/*!
=========================================================
* Muse Ant Design Dashboard - v1.0.0
=========================================================
* Product Page: https://www.creative-tim.com/product/muse-ant-design-dashboard
* Copyright 2021 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/muse-ant-design-dashboard/blob/main/LICENSE.md)
* Coded by Creative Tim
=========================================================
* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
import { Switch, Route, Redirect } from "react-router-dom";
import Home from "./pages/Home";
import Tables from "./pages/Tables";
import Billing from "./pages/Billing";
import Rtl from "./pages/Rtl";
import Main from "./components/layout/Main";
import 'antd/dist/antd.variable.min.css';
import "./assets/styles/main.css";
import "./assets/styles/responsive.css";
import {ConfigProvider} from "antd";
import AccessDeniedPage from "./pages/AccessDeniedPage";
import ProtectedRoute from "./navigation/Routes/ProtectedRoute";
import OIDCLogin from "./components/login/OIDCLogin";
import PageNotFound from "./pages/PageNotFound";
import {useEffect, useRef} from "react";
import {useDispatch, useSelector} from "react-redux";
import {loadAnswers, loadMyStacks, loadSummaries} from "./store/app/app.slice";
import {getAuthenticatedUser} from "./utils/authHelper";
import Portal from "./pages/Portal";
import LetterOverview from "./pages/LetterOverview";
import MyModifiedLettersOverview from "./pages/MyModifiedLettersOverview";
import Dashboard from "./pages/Dashboard";

import StacksOverview from "./pages/StacksOverview";
import MixedStacks from "./components/stacks/MixedStacks";
import StackDetail from "./components/stacks/StackDetail";
import StackLetterDetail from "./components/stacks/StackLetterDetail";
import LetterDetail from "./components/stacks/LetterDetail";
import SummariesAnswers from "./pages/SummariesAnswers";
import SummaryDashboard from "./pages/SummaryDashboard";
import SuspensionNotice from "./pages/SuspensionNotice";
import environments from "./utils/environments";

ConfigProvider.config({
    theme: {
        primaryColor: '#755B48'
    },
});

function App() {
    const { loggedInUser} = useSelector((state) => state.app);
    const dispatch = useDispatch();
    const amjUser = getAuthenticatedUser();
    const previousUserIdRef = useRef(null);
    
    useEffect(() => {
        if(loggedInUser && loggedInUser.id !== previousUserIdRef.current){
            previousUserIdRef.current = loggedInUser.id;
            dispatch(loadMyStacks({}));
            dispatch(loadSummaries({}));
            dispatch(loadAnswers({}));    
        }
    }, [loggedInUser, dispatch]);
    
    
        return (
            <OIDCLogin forceLoginRedirect={true}>
                <div className="App">
                    <Switch>
                        <Route exact path="/portal" children={<Portal/>}/>
                        <Main>
                            <Switch>
                                <Route exact path="/letters" children={<ProtectedRoute roles={["amj-portal-supervisor"]} element={<LetterOverview/>}/>}/>
                                <Route exact path="/lettersToHudhur" children={<ProtectedRoute roles={["amj-portal-supervisor"]}  element={<LetterOverview filtered={"toHudhur"}/>}/>}/>
                                <Route exact path="/myModifiedLetters" children={<ProtectedRoute element={<MyModifiedLettersOverview/>}/>}/>
                                <Route exact path="/letters/:letterId" children={<ProtectedRoute roles={["amj-portal-supervisor"]}  element={<LetterDetail/>}/>}/>
                                
                                <Route exact path="/stacks/:stackId" children={<ProtectedRoute roles={["amj-portal-supervisor"]}  element={<StackDetail inProcess={false}/>}/>}/>
                                <Route exact path="/stacks/:stackId/:letterId" children={<ProtectedRoute roles={["amj-portal-supervisor"]}  element={<StackLetterDetail inProcess={false}/>}/>}/>
                                
                                <Route exact path="/process/:stackType/stacks" children={<ProtectedRoute element={<StacksOverview/>}/>}/>
                                <Route exact path="/process/:stackType/stacks/:stackId" children={<ProtectedRoute element={<StackDetail inProcess={true}/>}/>}/>
                                <Route exact path="/process/:stackType/stacks/:stackId/:letterId" children={<ProtectedRoute element={<StackLetterDetail inProcess={true}/>}/>}/>
                                <Route exact path="/stacks" children={<ProtectedRoute  element={<StacksOverview key={"ArchiveStacksOverview"} archive={true}/>}/>}/>
                                
                                <Route exact path="/dashboard" children={<ProtectedRoute roles={["amj-portal-supervisor"]}  element={<Dashboard/>}/>}/>
                                <Route exact path="/summaries" children={<ProtectedRoute roles={["amj-international-admin"]}  element={<SummariesAnswers viewMode="summaries"/>}/>}/>
                                <Route exact path="/answers" children={<ProtectedRoute roles={["amj-international-admin"]}  element={<SummariesAnswers viewMode="answers"/>}/>}/>
                                {/*<Route exact path="/summaries-answers" children={<ProtectedRoute roles={["amj-international-admin"]}  element={<SummariesAnswers viewMode="both"/>}/>}/>*/}
                                <Route exact path="/summary-dashboard" children={<ProtectedRoute element={<SummaryDashboard/>}/>}/>
                                <Route exact path="/suspension-notice" children={<ProtectedRoute roles={["amj-portal-supervisor"]} element={<SuspensionNotice/>}/>}/>
                                <Route exact path="/error" children={<AccessDeniedPage/>}/>
                                <Route path='/accounts' component={() => {
                                    window.location.href = environments.accountAppUrl;
                                    return null;
                                }}/>
                                <Route path='/letterApp' component={() => {
                                    window.location.href = environments.letterAppUrl;
                                    return null;
                                }}/>
                                {amjUser?.isPortalSupervisor() ?
                                    <Redirect exact from="/" to="/letters"/>:
                                    amjUser?.isPortalUser() ? <Redirect exact from="/" to="/process/summary/stacks"/> : <Redirect exact from="/" to="/error"/>}
                                <Route path="/" children={<PageNotFound/>}/>
                            </Switch>
                        </Main>
                    </Switch>
                </div>
            </OIDCLogin>
        );
}

export default App;
